import { render, staticRenderFns } from "./MajorSection.vue?vue&type=template&id=753164fd"
import script from "./MajorSection.vue?vue&type=script&lang=js"
export * from "./MajorSection.vue?vue&type=script&lang=js"
import style0 from "./MajorSection.vue?vue&type=style&index=0&id=753164fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MajorTable: require('/app/nuxt/components/MajorTable.vue').default,Section: require('/app/nuxt/components/Section.vue').default})
